import FormFieldCheck from '@/store/Form/requestFormFieldCheck';

const getDefaultState = () => {
  return {
    sendData: {
      WORK_JOB_DADATA: { data: {inn: ''}},
      BIRTHDAY: '',
      BIRTHPLACE: '',
      CALC_SUMM: '',
      CALC_WEEK: '52',
      CAR_NUMBER: '',
      CONST_INCOME: '',
      CREDHISTORY_RADIO: '',
      EMAIL: '',
      EXPER_RADIO: '',
      FIRST_NAME: '',
      GENDER: 'M',
      IS_ADDRESS_COINCIDES: 'N',
      IS_I_CERTIFY_REGISTRATION: 'Y',
      LAST_NAME: '',
      MEETING_DATE: '',
      MEETING_HOUR: '',
      CALL_DATE: 'not selected',
      CALL_HOUR: 'not selected',
      OTHER_SOURCES_OF_INCOME: '',
      PASSPORT_DATE: '',
      PASSPORT_DEP: '',
      PASSPORT_DEP_CODE: '',
      PASSPORT_NUMBER: '',
      PASSPORT_SERIES: '',
      PHONE: '',
      PRODUCT_ID: 'S',
      REGISTRATION_ADDRESS: '',
      REGISTRATION_ADDRESS_DADATA: {data:{postal_code:'',country:'',country_iso_code:'',federal_district:'',region_fias_id:'',region_kladr_id:'',region_iso_code:'',region_with_type:'',region_type:'',region_type_full:'',region:'',area_fias_id:'',area_kladr_id:'',area_with_type:'',area_type:'',area_type_full:'',area:'',city_fias_id:'',city_kladr_id:'',city_with_type:'',city_type:'',city_type_full:'',city:'',city_area:'',city_district_fias_id:'',city_district_kladr_id:'',city_district_with_type:'',city_district_type:'',city_district_type_full:'',city_district:'',settlement_fias_id:'',settlement_kladr_id:'',settlement_with_type:'',settlement_type:'',settlement_type_full:'',settlement:'',street_fias_id:'',street_kladr_id:'',street_with_type:'',street_type:'',street_type_full:'',street:'',house_fias_id:'',house_kladr_id:'',house_type:'',house_type_full:'',house:'',block_type:'',block_type_full:'',block:'',flat_type:'',flat_type_full:'',flat:'',flat_area:'',square_meter_price:'',flat_price:'',postal_box:'',fias_id:'',fias_code:'',fias_level:'',fias_actuality_state:'',kladr_id:'',geoname_id:'',capital_marker:'',okato:'',oktmo:'',tax_office:'',tax_office_legal:'',timezone:'',geo_lat:'',geo_lon:'',beltway_hit:'',beltway_distance:'',metro:'',qc_geo:'',qc_complete:'',qc_house:'',history_values:'',unparsed_parts:'',source:'',qc:''}},
      RESIDENTIAL_ADDRESS: '',
      RESIDENTIAL_ADDRESS_DADATA: {data:{postal_code:'',country:'',country_iso_code:'',federal_district:'',region_fias_id:'',region_kladr_id:'',region_iso_code:'',region_with_type:'',region_type:'',region_type_full:'',region:'',area_fias_id:'',area_kladr_id:'',area_with_type:'',area_type:'',area_type_full:'',area:'',city_fias_id:'',city_kladr_id:'',city_with_type:'',city_type:'',city_type_full:'',city:'',city_area:'',city_district_fias_id:'',city_district_kladr_id:'',city_district_with_type:'',city_district_type:'',city_district_type_full:'',city_district:'',settlement_fias_id:'',settlement_kladr_id:'',settlement_with_type:'',settlement_type:'',settlement_type_full:'',settlement:'',street_fias_id:'',street_kladr_id:'',street_with_type:'',street_type:'',street_type_full:'',street:'',house_fias_id:'',house_kladr_id:'',house_type:'',house_type_full:'',house:'',block_type:'',block_type_full:'',block:'',flat_type:'',flat_type_full:'',flat:'',flat_area:'',square_meter_price:'',flat_price:'',postal_box:'',fias_id:'',fias_code:'',fias_level:'',fias_actuality_state:'',kladr_id:'',geoname_id:'',capital_marker:'',okato:'',oktmo:'',tax_office:'',tax_office_legal:'',timezone:'',geo_lat:'',geo_lon:'',beltway_hit:'',beltway_distance:'',metro:'',qc_geo:'',qc_complete:'',qc_house:'',history_values:'',unparsed_parts:'',source:'',qc:''}},
      SECOND_NAME: '',
      WORK_JOB: '',
      WHERE_TO_FIND_US: 'Базы потенциальных клиентов',
      REFFER: 'ЛК агента',
      SmsConfCode: '',
      INN: '',
      WORK_TITLE:'',
      WORK_TITLE_GIG_DATA:'',
      ENTERPRISE_ID:'',
      ENTERPRISE_NAME:'',
    },
    workData: {
      WORK_JOB_DADATA: {code: 0, msg: '', ShowError: false},
      BIRTHDAY: {code: 1, msg: 'обязательное поле', ShowError: false},
      BIRTHPLACE: {code: 1, msg: 'обязательное поле', ShowError: false},
      CALC_SUMM: {code: 0, msg: 'обязательное поле', ShowError: false},
      CALC_WEEK: {code: 0, msg: '', ShowError: false},
      CAR_NUMBER: {code: 0, msg: '', ShowError: false},
      CONST_INCOME: {code: 1, msg: 'обязательное поле', ShowError: false},
      CREDHISTORY_RADIO: {code: 1, msg: 'обязательное поле', ShowError: false},
      EMAIL: {code: 1, msg: 'обязательное поле', ShowError: false},
      EXPER_RADIO: {code: 1, msg: 'обязательное поле', ShowError: false},
      FIRST_NAME: {code: 1, msg: 'обязательное поле', ShowError: false},
      GENDER: {code: 1, msg: 'обязательное поле', ShowError: false},
      IS_ADDRESS_COINCIDES: {code: 0, msg: '', ShowError: false},
      IS_I_CERTIFY_REGISTRATION: {code: 0, msg: '', ShowError: false},
      LAST_NAME: {code: 1, msg: 'обязательное поле', ShowError: false},
      MEETING_DATE: {code: 1, msg: 'обязательное поле', ShowError: false},
      MEETING_HOUR: {code: 1, msg: 'обязательное поле', ShowError: false},
      CALL_DATE: {code: 1, msg: 'обязательное поле', ShowError: false},
      CALL_HOUR: {code: 1, msg: 'обязательное поле', ShowError: false},
      OTHER_SOURCES_OF_INCOME: {code: 1, msg: 'обязательное поле', ShowError: false},
      PASSPORT_DATE: {code: 1, msg: 'обязательное поле', ShowError: false},
      PASSPORT_DEP: {code: 1, msg: 'обязательное поле', ShowError: false},
      PASSPORT_DEP_CODE: {code: 1, msg: 'обязательное поле', ShowError: false},
      PASSPORT_NUMBER: {code: 1, msg: 'обязательное поле', ShowError: false},
      PASSPORT_SERIES: {code: 1, msg: 'обязательное поле', ShowError: false},
      PHONE: {code: 1, msg: 'обязательное поле', ShowError: false},
      PRODUCT_ID: {code: 0, msg: '', ShowError: false},
      REGISTRATION_ADDRESS: {code: 1, msg: 'обязательное поле, адрес нужно выбрать из выпадающего списка', ShowError: false},
      REGISTRATION_ADDRESS_DADATA: {code: 0, msg: 'обязательное поле', ShowError: false},
      RESIDENTIAL_ADDRESS: {code: 1, msg: 'обязательное поле, адрес нужно выбрать из выпадающего списка', ShowError: false},
      RESIDENTIAL_ADDRESS_DADATA: {code: 0, msg: 'обязательное поле', ShowError: false},
      SECOND_NAME: {code: 1, msg: 'обязательное поле', ShowError: false},
      WORK_JOB: {code: 0, msg: '', ShowError: false},
      WHERE_TO_FIND_US: {code: 0, msg: '', ShowError: false},
      REFFER: {code: 0, msg: '', ShowError: false},
      SmsConfCode: {code: 0, msg: '', ShowError: false},
      INN: {code: 0, msg: '', ShowError: false},
      WORK_TITLE:{code: 0, msg: '', ShowError: false},
      WORK_TITLE_GIG_DATA:{code: 0, msg: '', ShowError: false},
    },
    system: {
      loading: false,
      currentFormScreen: 'frstStep',
      scrMsg:'Извините, произошел технический сбой. Наши специалисты уже занимаются решением проблемы. Попробуйте' +
        ' заполнить заявку позже.',
      isMobileAdressForm: false,
    },
    mobileSuggestion:{
      REGISTRATION_ADDRESS:{
        area:'',
        city:'',
        street:'',
        house:'',
        deportament:'',
      },
      RESIDENTIAL_ADDRESS:{
        area:'',
        city:'',
        street:'',
        house:'',
        deportament:'',
      }
    },
    comparison: {
      REGISTRATION_ADDRESS: 'RESIDENTIAL_ADDRESS',
      REGISTRATION_ADDRESS_DADATA: 'RESIDENTIAL_ADDRESS_DADATA',
      RESIDENTIAL_ADDRESS: 'REGISTRATION_ADDRESS',
      RESIDENTIAL_ADDRESS_DADATA: 'REGISTRATION_ADDRESS_DADATA',
    },
    addrTypes: [
      'REGISTRATION_ADDRESS',
      'RESIDENTIAL_ADDRESS',
    ],
  }
};

const TestSendData = () => {
  return {
    BIRTHDAY: '1986.12.12',
    BIRTHPLACE: 'фывфыв',
    CALC_SUMM: '22000',
    CALC_WEEK: '52',
    CAR_NUMBER: '',
    CONST_INCOME: '123',
    CREDHISTORY_RADIO: '123',
    EMAIL: '123',
    EXPER_RADIO: '123',
    FIRST_NAME: 'тест',
    GENDER: 'M',
    IS_ADDRESS_COINCIDES: 'N',
    IS_I_CERTIFY_REGISTRATION: 'Y',
    LAST_NAME: 'тест',
    MEETING_DATE: '2020.12.12',
    MEETING_HOUR: '12:12',
    OTHER_SOURCES_OF_INCOME: '123123',
    PASSPORT_DATE: '1986.12.12',
    PASSPORT_DEP: '123123',
    PASSPORT_DEP_CODE: '111-11',
    PASSPORT_NUMBER: '111111',
    PASSPORT_SERIES: '1111',
    PHONE: '+7 (903) 207-38-48',
    PRODUCT_ID: 'S',
    // REGISTRATION_ADDRESS: 'г Москва, ул Грина, д 5',
    // REGISTRATION_ADDRESS_DADATA: {"value":"г Москва, ул Грина, д 5","unrestricted_value":"117216, г Москва, ул Грина, д 5","data":{"postal_code":"117216","country":"Россия","country_iso_code":"RU","federal_district":null,"region_fias_id":"0c5b2444-70a0-4932-980c-b4dc0d3f02b5","region_kladr_id":"7700000000000","region_iso_code":"RU-MOW","region_with_type":"г Москва","region_type":"г","region_type_full":"город","region":"Москва","area_fias_id":null,"area_kladr_id":null,"area_with_type":null,"area_type":null,"area_type_full":null,"area":null,"city_fias_id":"0c5b2444-70a0-4932-980c-b4dc0d3f02b5","city_kladr_id":"7700000000000","city_with_type":"г Москва","city_type":"г","city_type_full":"город","city":"Москва","city_area":null,"city_district_fias_id":null,"city_district_kladr_id":null,"city_district_with_type":null,"city_district_type":null,"city_district_type_full":null,"city_district":null,"settlement_fias_id":null,"settlement_kladr_id":null,"settlement_with_type":null,"settlement_type":null,"settlement_type_full":null,"settlement":null,"street_fias_id":"242912a9-7de3-4120-8bee-8dca086df20f","street_kladr_id":"77000000000114000","street_with_type":"ул Грина","street_type":"ул","street_type_full":"улица","street":"Грина","house_fias_id":"147f2281-ef84-4759-9b03-4562e4b7deb0","house_kladr_id":"7700000000011400032","house_type":"д","house_type_full":"дом","house":"5","block_type":null,"block_type_full":null,"block":null,"flat_type":null,"flat_type_full":null,"flat":null,"flat_area":null,"square_meter_price":null,"flat_price":null,"postal_box":null,"fias_id":"147f2281-ef84-4759-9b03-4562e4b7deb0","fias_code":null,"fias_level":"8","fias_actuality_state":null,"kladr_id":"7700000000011400032","geoname_id":null,"capital_marker":"0","okato":"45293582000","oktmo":"45906000","tax_office":"7727","tax_office_legal":"7727","timezone":null,"geo_lat":null,"geo_lon":null,"beltway_hit":null,"beltway_distance":null,"metro":null,"qc_geo":null,"qc_complete":null,"qc_house":null,"history_values":null,"unparsed_parts":null,"source":null,"qc":null}},
    // RESIDENTIAL_ADDRESS: 'г Москва, ул Грина, д 5',
    // RESIDENTIAL_ADDRESS_DADATA: {"value":"г Москва, ул Грина, д 5","unrestricted_value":"117216, г Москва, ул Грина, д 5","data":{"postal_code":"117216","country":"Россия","country_iso_code":"RU","federal_district":null,"region_fias_id":"0c5b2444-70a0-4932-980c-b4dc0d3f02b5","region_kladr_id":"7700000000000","region_iso_code":"RU-MOW","region_with_type":"г Москва","region_type":"г","region_type_full":"город","region":"Москва","area_fias_id":null,"area_kladr_id":null,"area_with_type":null,"area_type":null,"area_type_full":null,"area":null,"city_fias_id":"0c5b2444-70a0-4932-980c-b4dc0d3f02b5","city_kladr_id":"7700000000000","city_with_type":"г Москва","city_type":"г","city_type_full":"город","city":"Москва","city_area":null,"city_district_fias_id":null,"city_district_kladr_id":null,"city_district_with_type":null,"city_district_type":null,"city_district_type_full":null,"city_district":null,"settlement_fias_id":null,"settlement_kladr_id":null,"settlement_with_type":null,"settlement_type":null,"settlement_type_full":null,"settlement":null,"street_fias_id":"242912a9-7de3-4120-8bee-8dca086df20f","street_kladr_id":"77000000000114000","street_with_type":"ул Грина","street_type":"ул","street_type_full":"улица","street":"Грина","house_fias_id":"147f2281-ef84-4759-9b03-4562e4b7deb0","house_kladr_id":"7700000000011400032","house_type":"д","house_type_full":"дом","house":"5","block_type":null,"block_type_full":null,"block":null,"flat_type":null,"flat_type_full":null,"flat":null,"flat_area":null,"square_meter_price":null,"flat_price":null,"postal_box":null,"fias_id":"147f2281-ef84-4759-9b03-4562e4b7deb0","fias_code":null,"fias_level":"8","fias_actuality_state":null,"kladr_id":"7700000000011400032","geoname_id":null,"capital_marker":"0","okato":"45293582000","oktmo":"45906000","tax_office":"7727","tax_office_legal":"7727","timezone":null,"geo_lat":null,"geo_lon":null,"beltway_hit":null,"beltway_distance":null,"metro":null,"qc_geo":null,"qc_complete":null,"qc_house":null,"history_values":null,"unparsed_parts":null,"source":null,"qc":null}},
    SECOND_NAME: 'тест',
    WORK_JOB: 'asdasd',
  }
}

function transformValueBeforeSave(workArr) {
  let phoneFieldArr = ['PHONE', 'PHONE_ADDITIONAL', 'PHONE_FOR_CALL'];

  if (phoneFieldArr.includes(workArr.target)) {
    // let str = workArr.value;
    // workArr.value = '+7 (' + str.slice(0,3) + ') ' + str.slice(3,6) + '-' + str.slice(6,8) + '-'  + str.slice(8,10);
  }

  return workArr.value;
}

const state = getDefaultState();

const getters = {
  getTargetFieldValue: (state) => (target) => state.sendData['request'][target],
  isAdressValid: (state) => (target) => {
    if (state.sendData[target] == '' && state.sendData[target + '_DADATA'].value == '') {
      return 'Обязательное поле, Вы должны выбрать адрес из выпадающего списка';
    }

    if (state.sendData[target + '_DADATA'].value !=  state.sendData[target]) {
      return 'Вы должны выбрать адрес из выпадающего списка';
    }

    try {
      if (state.sendData[target + '_DADATA'].data.house == null) {
        return 'Адрес не полный, укажите город, улицу и номер дома';
      }
    } catch (e) {
      return 'Адрес не корректный';
    }
    return '';
  },
  getMobileAdressSuggestion: (state) => (target) => {
    return state.mobileSuggestion[target].area + ' ' +
            state.mobileSuggestion[target].city + ' ' +
            state.mobileSuggestion[target].street + ' ' +
            state.mobileSuggestion[target].house + ' ' +
            state.mobileSuggestion[target].deportament;
  }
};

const actions = {
  setMobileAdressSuggestion:({commit}, requestFields)=>{
    commit('saveMobileAdressSuggestion', requestFields);
},
  setRequestField: ({dispatch}, requestFields) => {
    try {
      Object.keys(requestFields).forEach(function (key) {
        if (key in state.sendData) {
          if (requestFields[key] !== state.sendData[key] && requestFields[key] != '') {
            dispatch('saveSendData', {
              target: key,
              value: requestFields[key],
            });
          }
        }
      });
    } catch (e) {
      console.log(e);
    }
  },
  saveSendData: ({commit, dispatch}, workArr) => {
    //eslint-disable-next-line no-debugger
    // debugger;
    if (workArr.value === undefined) {
      return false;
    }
    workArr.value = transformValueBeforeSave(workArr);

    if (state.sendData[workArr.target] === workArr.value ) {
      return false;
    }
    let statusArr = {};
    if (typeof FormFieldCheck[workArr.target] == 'function') {
      statusArr = FormFieldCheck[workArr.target](workArr.value);
    } else {
      statusArr = FormFieldCheck.isEmpty(workArr.value);
    }
    workArr['status'] = statusArr;

    //todo переписать и найти решение, проблема как указать дерективу на инпут с уникальным шаблоном маски, если не каждому инпуту нужна такая директива.
    if (typeof FormFieldCheck[workArr.target + 'maskKostil'] == 'function') {
      workArr.value = FormFieldCheck[workArr.target + 'maskKostil'](workArr.value);
    }


    commit('saveSendData', workArr);
    commit('saveWorkData', workArr);

    if (workArr.target == 'IS_ADDRESS_COINCIDES') {
      dispatch('isAdressConsides')
    }


    if (state.sendData.IS_ADDRESS_COINCIDES === 'Y') {
      let ind = state.addrTypes.findIndex((item) => {
        return item === workArr.target || item + '_DADATA' === workArr.target
      })

      if (ind >= 1) {
        state.addrTypes.reverse()
      }

      dispatch('saveAddr', {from: state.addrTypes[0], to: state.addrTypes[1]});
      dispatch('saveAddr', {from: state.addrTypes[0] + '_DADATA', to: state.addrTypes[1] + '_DADATA'});
    }

    if(workArr.target === 'WORK_TITLE') {
      commit('saveSendData', {
        target: 'WORK_TITLE_GIG_DATA',
        value: workArr.jsonSuggestion
      });
    }

  },

  resetToDefault: ({commit}) => {
    return new Promise(resolve => {
      commit('resetState');
      resolve();
    });
  },
  setTest: ({commit}) => {
    return new Promise(resolve => {
      commit('testData');
      resolve();
    });
  },
  isAdressConsides: ({dispatch}) => {

    if (state.sendData.IS_ADDRESS_COINCIDES === 'Y') {
      if (state.sendData.REGISTRATION_ADDRESS.length === 0) {
       state.addrTypes.reverse();
      }
      dispatch('saveAddr', {from: state.addrTypes[0], to: state.addrTypes[1]});
      dispatch('saveAddr', {from: state.addrTypes[0] + '_DADATA', to: state.addrTypes[1] + '_DADATA'});
    }
  },
  saveAddr({commit}, obj) {
      let workArr = {
        target: '',
        value: ''
      };
      let statusArr = {};

      workArr.target = obj.to;
      workArr.value = state.sendData[obj.from];

      if (typeof FormFieldCheck[workArr.target] == 'function') {
        statusArr = FormFieldCheck[workArr.target](workArr.value);
      } else {
        statusArr = FormFieldCheck.isEmpty(workArr.value);
      }

      workArr['status'] = statusArr;
      commit('saveSendData', workArr);
      commit('saveWorkData', workArr);
  },
  systemUpdate: ({commit}, valueObj) => {
    if (valueObj.target == undefined && valueObj.value == undefined) return false;
    commit('saveSystemData', valueObj);
  },
  errorShow: ({commit}, valueObj) => {
    if (valueObj.target == undefined && valueObj.value == undefined) return false;
    commit('saveErrorShow', valueObj);
  },
  showLoading:({commit}) =>{
    commit('saveSystemData',{
      target:'loading',
      value: true,
    });
  },
  hideLoading:({commit}) =>{
    commit('saveSystemData',{
      target:'loading',
      value: false,
    });
  },
  formRouting:({commit}, target) => {
    commit('saveSystemData', {
      target: 'currentFormScreen',
      value: target
    });
  },
  fieldError:({commit},valueObj) => {
    if (valueObj.target == undefined && valueObj.value == undefined) return false;
    commit('saveErrorShow', {
      target:valueObj.target,
      value:true,
    });
    commit('kostil', 1);

    commit('saveErrorMsg', valueObj);
  },
};
//todo убрать лишние сохронялки в хранилише, проверять на совпадение новго и старого значения.
const mutations = {
  saveSendData: (state, newVal) => state.sendData[newVal.target] = newVal.value,
  saveWorkData: (state, newVal) => {
    state.workData[newVal.target].code = newVal.status.code;
    state.workData[newVal.target].msg = newVal.status.msg;
  },
  kostil:(state, newVal) => state.workData.PHONE.code = newVal,
  saveErrorShow: (state, valueObj) => state.workData[valueObj.target].ShowError = valueObj.value,
  saveErrorMsg: (state, valueObj) => state.workData[valueObj.target].msg = valueObj.value,
  saveSystemData: (state, valueObj) => state.system[valueObj.target] = valueObj.value,
  resetState: (state) => Object.assign(state, getDefaultState()),
  testData: (state) => Object.assign(state.sendData, TestSendData()),
  saveScrMsg: (state, str) => state.system.scrMsg = str,
  selectAdressForm: (state) =>{

    state.system.isMobileAdressForm = window.outerWidth < 760

  },
  saveMobileAdressSuggestion: (state, valueObj) => {
    state.mobileSuggestion[valueObj.target][valueObj.adresPart] = valueObj.value;
  }
};


export default {
  state,
  getters,
  actions,
  mutations,
}
